import React from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";

import styled from "@emotion/styled";
import {withStyles} from "@material-ui/core";

import ExpansionPanelTableHeadingComponent from "../common/ExpansionPanelTableHeadingComponent";
import ExpansionPanelTableRowComponent from "../common/ExpansionPanelTableRowComponent";

import tableHeadings from "../../data/tableHeadings/ContractsTableHeading"
import Icon from "@material-ui/core/Icon";
import {CONTRACT_STATUS} from '../../utils/contracts';


const CustomerExpansionPanel = withStyles({
    root: {
        position: "unset",
        margin: "20px 0",
        boxShadow: "unset"
    },
    expanded : {
        background: "#FAFAFA",
        border: "1px solid #E3E8EF",
        boxSizing: "border-box",
        boxShadow: "inset 0px 2px 4px rgba(0, 0, 0, 0.05)",
        borderRadius: "8px"
    }
})(ExpansionPanel);


const Wrapper = styled.div`
  width: 100%;
`;

const ExpansionHeading = styled.div`
    display: flex;
    align-items: center;
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    /* default/blue/700 */
    color: var(--color-blue-700);
`;


const ExpansionGroupInfo = styled.div`
    display: grid;
    grid-auto-flow: column;
    
    grid-column-gap: 50px;
`;

const SummaryWrapper = styled.div`
    display: flex;
    width: 100%;
    //padding: 0 24px;
    
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const ExpansionTableWrapper = styled.div`
    overflow: scroll;
    padding: 0 24px 66px 24px;
    flex: 1;
`;

function CompanyContractExpansionPanel({contractGroups, selectedContracts, onCheckBoxSelected, onSelectAll, expandedItems, onExpanded}) {

    Object.keys(contractGroups).map( (groupItem, index) => {

    });

    const handleExpandChange = (event, expanded) => {

    };

    return (
        <Wrapper>
            {
                Object.keys(contractGroups).map( (groupName, index) => {
                       const contracts = contractGroups[groupName];
                       const contractNum = contracts.length;

                       let contractSigned = 0;
                       let numPolicies = 0;

                       const isExpanded = (value) => expandedItems.includes(value);
                       const isSelected = (value) => selectedContracts.includes(value.id);
                       const checked = contracts.every(isSelected);

                       // indeterminate if one ore more but not all contracts in the group is selected.
                       const indeterminate = contracts.some(isSelected) && !checked;


                       contracts.forEach( item => {
                           numPolicies += item.policies;

                           if (
                               // If the contract are in one of the following states it has not been approved
                               item.status !== CONTRACT_STATUS.CONTRACT_GENERATED &&
                               item.status !== CONTRACT_STATUS.CUSTOMER_SIGNED &&
                               item.status !== CONTRACT_STATUS.CONTRACT_REVIEW
                           ) contractSigned++;
                       });

                       return <CustomerExpansionPanel
                           key={groupName}
                           onChange={(e, expanded) => onExpanded(groupName, expanded)}
                           expanded={isExpanded(groupName)}
                           value={groupName}
                       >
                           <ExpansionPanelSummary>
                                <SummaryWrapper>
                                    <ExpansionHeading>
                                        <Icon
                                            fontSize="small"
                                            style={{
                                                color: "var(--color-gray-700)",
                                                marginBottom: 4,
                                                marginLeft: 8,
                                                marginRight: 24
                                            }}
                                        >
                                            keyboard_arrow_right
                                        </Icon>
                                        {groupName}
                                    </ExpansionHeading>

                                    <ExpansionGroupInfo>
                                        <span> {contractNum} Contracts </span>
                                        <span> {contractNum - contractSigned} Unsigned</span>
                                        <span> {numPolicies || `...`} Policies </span>
                                    </ExpansionGroupInfo>
                                </SummaryWrapper>
                           </ExpansionPanelSummary>


                           <ExpansionTableWrapper>
                                <ExpansionPanelTableHeadingComponent
                                    tableHeadings={tableHeadings} hasCheckBox={true}
                                    isChecked={checked}
                                    indeterminate={indeterminate}
                                    onCheckBoxClicked={(e) => onSelectAll(e, contracts, indeterminate)}
                                />
                                {
                                    contracts.map( (contractItem, index) =>
                                            <ExpansionPanelTableRowComponent
                                                key={index + Math.random()}
                                                isSelected={isSelected(contractItem)}
                                                onCheckBoxSelected={onCheckBoxSelected}
                                                hasCheckBox={true}
                                                tableHeadings={tableHeadings}
                                                rowData={contractItem["tableFields"]}
                                            />
                                    )
                                }
                            </ExpansionTableWrapper>
                    </CustomerExpansionPanel>
                    }
                )
            }
        </Wrapper>
    );
}

CompanyContractExpansionPanel.propTypes = {};
CompanyContractExpansionPanel.defaultProps = {};

export default CompanyContractExpansionPanel;
